import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import getRandom from '../util/getRandom';

const INITIAL_STATE = Immutable({
  checklistItemGroups: [],
  checklistItems: [],
  isLoading: false,
  isLoadingResults: false,
  isLoadingChecklistItems: false,
  checklistItemsByChecklistItemGroup: {},
  checklistToDos: [],
});

export const selectChecklistItemGroup = createAction(
  'SELECTCHECKLISTITEMGROUP'
);

// api actions
export const onLoadChecklistItemGroups = createAction(
  'ONLOADCHECKLISTITEMGROUPS'
);
export const onLoadChecklistItemGroup = createAction(
  'ONLOAD_ChecklistItemGroup_CHECKLISTITEMS'
);
export const onLoadChecklistItemsForChecklist = createAction(
  'ONLOAD_CHECKLISTITEMS_FOR_CHECKLIST'
);

// utils
export const onLoadChecklistItemGroupsSucceeded = createAction(
  'ONLOADCHECKLISTITEMGROUPSSUCCEEDED'
);
export const onLoadChecklistItemGroupsFailed = createAction(
  'ONLOADCHECKLISTITEMGROUPSFAILED'
);
export const onLoadChecklistItemsForChecklistSucceeded = createAction(
  'ONLOADCHECKLISTITEMSFORCHECKLISTSUCCEEDED'
);
export const onLoadChecklistItemsForChecklistFailed = createAction(
  'ONLOADCHECKLISTITEMSFORCHECKLISTFAILED'
);

export const onLoadChecklistItemGroupSucceeded = createAction(
  'ONLOAD_CHECKLISTITEMGROUP_CHECKLISTITEMSSUCCEEDED'
);
export const onLoadChecklistItemGroupFailed = createAction(
  'ONLOAD_CHECKLISTITEMGROUP_CHECKLISTITEMSFAILED'
);

export const onLoadAllChecklistItemGroupChecklistItems = createAction(
  'ONLOADALLCHECKLISTITEMGROUPCHECKLISTITEMS'
);

export const onCloseCompletedDialog = createAction('completedDialogOpenAction');

export const loadSingleChecklistItem = createAction('LOADSINGLECHECKLISTITEM');
export const loadSingleChecklistItemSucceeded = createAction(
  'LOADSINGLECHECKLISTITEMSUCCESS'
);
export const loadSingleChecklistItemFailed = createAction(
  'LOADSINGLECHECKLISTITEMFAILED'
);

const findChecklistItemGroup = (checklistItemGroups, id) => {
  for (let i = checklistItemGroups.length - 1; i >= 0; i--) {
    const checklistItemGroup = checklistItemGroups[i];

    if (
      (checklistItemGroup.type == 'checklistItemGroup' ||
        checklistItemGroup.type == null) &&
      checklistItemGroup.id == id
    ) {
      return checklistItemGroup;
    }

    if (checklistItemGroup.type == 'group' && checklistItemGroup.children) {
      for (let j = checklistItemGroup.children.length - 1; j >= 0; j--) {
        if (
          checklistItemGroup.children[j] &&
          checklistItemGroup.children[j].type == 'checklistItemGroup' &&
          checklistItemGroup.children[j].id == id
        ) {
          return checklistItemGroup.children[j];
        }
      }
    }
  }
};

const loadChecklistItems = (
  state,
  { checklistItemGroup, checklistItems, result }
) => {
  const checklistItemsByChecklistItemGroup =
    state.checklistItemsByChecklistItemGroup.setIn(
      [checklistItemGroup.id],
      checklistItems
    );

  const selectedChecklistItemGroup = result
    ? findChecklistItemGroup(state.results, checklistItemGroup.id)
    : findChecklistItemGroup(
        state.checklistItemGroups,
        checklistItemGroup.id
      ) || checklistItemGroup;
  return state.merge({
    checklistItemsByChecklistItemGroup,
    checklistItems,
    runStartedAt: new Date().toISOString(),
    correctAnswersCount: 0,
    selectedChecklistItemGroup,
    previewChecklistItemGroups: getRandom(
      state.checklistItemGroups.filter((t) => t.id != checklistItemGroup.id),
      Math.min(4, state.checklistItemGroups.length - 1)
    ),
    selectedChecklistItemGroupId: checklistItemGroup.id * 1,
    isLoadingChecklistItems: false,
  });
};

const selectChecklistItemGroupReducer = (state, checklistItemGroup) => {
  const selectedChecklistItemGroup = findChecklistItemGroup(
    state.checklistItemGroups,
    checklistItemGroup.id
  );
  const checklistItemGroupRun = state.checklistItemGroupRuns.find(
    (t) => t.checklistItemGroupId === checklistItemGroup.id
  );

  return state.merge({
    selectedChecklistItemGroup,
    selectedChecklistItemGroupId: checklistItemGroup.id * 1,
    isLoadingChecklistItems: true,
    checklistItemGroupRun,
  });
};

const reducers = createReducer(
  {
    [onLoadChecklistItemGroups]: (state) => state.merge({ isLoading: true }),
    [selectChecklistItemGroup]: selectChecklistItemGroupReducer,
    [onLoadChecklistItemGroupsSucceeded]: (state, { checklistItemGroups }) =>
      state.merge({
        checklistItemGroups,
        previewChecklistItemGroups: getRandom(
          checklistItemGroups,
          Math.min(4, checklistItemGroups.length - 1)
        ),
        isLoading: false,
      }),
    [onLoadChecklistItemsForChecklist]: (state) =>
      state.merge({ isLoading: true }),
    [onLoadChecklistItemsForChecklistSucceeded]: (
      state,
      { checklistItems }
    ) => {
      return state.merge({
        checklistItems,
        isLoading: false,
      });
    },
    [onLoadChecklistItemGroupSucceeded]: loadChecklistItems,
    [onLoadAllChecklistItemGroupChecklistItems]: (state) =>
      state.merge({ isLoadingChecklistItems: true }),
    // [onSubmitChecklistItemGroup]: state => state.merge({ completedDialogOpen: true }),
    [onCloseCompletedDialog]: (state) =>
      state.merge({ completedDialogOpen: false }),
    [onLoadAllChecklistItemGroupChecklistItems]: (state) =>
      state.merge({ isLoadingChecklistItems: true }),
    [loadSingleChecklistItemSucceeded]: (state, currentChecklistItem) =>
      state.merge({ currentChecklistItem }),
  },
  INITIAL_STATE
);

export default reducers;



// WEBPACK FOOTER //
// ./src/app/reducers/checklistItemGroup.reducers.js